import React, { forwardRef } from 'react';

const TONE_CLASS = {
  info: 'bg-apple-blue/15 border border-apple-blue/40 text-apple-blue',
  warning: 'bg-yellow-900/20 border border-yellow-700/50 text-yellow-300',
  error: 'bg-apple-error/15 border border-apple-error/40 text-apple-error',
  success: 'bg-apple-success/15 border border-apple-success/40 text-apple-success',
};

const TITLE_CLASS = {
  info: 'text-apple-blue',
  warning: 'text-yellow-400',
  error: 'text-apple-error',
  success: 'text-apple-success',
};

/**
 * Status / callout banner.
 *
 * @param {object} props
 * @param {'info'|'warning'|'error'|'success'} [props.tone='info']
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.children]
 * @param {string} [props.className]
 */
const Alert = forwardRef(function Alert(
  { tone = 'info', title, children, className = '', ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      role="alert"
      className={`rounded-lg p-4 ${TONE_CLASS[tone] || TONE_CLASS.info} ${className}`.trim()}
      {...rest}
    >
      {title && (
        <p className={`font-semibold mb-1 ${TITLE_CLASS[tone] || TITLE_CLASS.info}`}>{title}</p>
      )}
      {children && <div className="text-sm font-normal">{children}</div>}
    </div>
  );
});

export default Alert;
